
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import Select from "react-select";

import { ApiUrl } from "../../../ApiUrl";

const SelectStudentModal = ({
  show,
  handleClose,
  onSelectStudent,
  hostelAvailedOnly = false,
}) => {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [students, setStudents] = useState([]);
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentError, setStudentError] = useState("");
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();
  const [studentData, setStudentData] = useState([]);
  const [fullStudentData, setFullStudentData] = useState([]);
  const [filters, setFilters] = useState({
    studentName: "",
    barcode: "",
    classId: "",
    section: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });

  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(selectedClass);

  // Auto-fetch all students when modal opens
  useEffect(() => {
    if (show) {
      handleSearch(); // Fetch all students with empty filters to show everyone
    }
  }, [show]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // const handleSearch = async () => {
  //   try {
  //     const academicSessionId = localStorage.getItem("academicSessionId");
  //     if (!academicSessionId) {
  //       console.error("No academic session ID found in local storage");
  //       return;
  //     }

  //     // Construct the search parameters from the filter values
  //     const queryParams = new URLSearchParams({
  //       studentName: filters.studentName || "",
  //       admissionNo: filters.admissionNo || "",
  //       barcode: filters.barcode || "",
  //       schoolAdmissionNo: filters.schoolAdmissionNo || "",
  //       classId: filters.classId || "",
  //       section: filters.sectionId || "",
  //       fatherName: filters.fatherName || "",
  //       motherName: filters.motherName || "",
  //     }).toString();

  //     // Fetch filtered data based on search
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}?${queryParams}`
  //     );

  //     if (!response.ok) {
  //       throw new Error("Error fetching student data");
  //     }

  //     const data = await response.json();
  //     if (data.data) {
  //       setFullStudentData(data.data);
  //       setStudentData(data.data);
  //     } else {
  //       console.warn("No data found for the given filters");
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error);
  //   }
  // };

  const handleSearch = async () => {
    try {
      const academicSessionId = localStorage.getItem("academicSessionId");
      if (!academicSessionId) {
        console.error("No academic session ID found in local storage");
        return;
      }

      const queryParams = new URLSearchParams({
        academic_year_id: academicSessionId,
      });

      const filterParams = {
        studentName: filters.studentName,
        classId: filters.classId,
        sectionId: filters.sectionId,
        barcode: filters.barcode,
        fatherName: filters.fatherName,
        motherName: filters.motherName,
        schoolAdmissionNo: filters.schoolAdmissionNo,
      };

      Object.entries(filterParams).forEach(([key, value]) => {
        if (value) {
          queryParams.set(key, value);
        }
      });

      const queryString = hostelAvailedOnly
        ? `${queryParams.toString()}&hostel_availed=true&exclude_hostel_assigned=true&session_id=${academicSessionId}`
        : queryParams.toString();

      const response = await fetch(
        `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSRECORDFILTER/?${queryString}`
      );

      if (!response.ok) {
        throw new Error("Error fetching student data");
      }

      const data = await response.json();

      if (Array.isArray(data.data)) {
        setFullStudentData(data.data);
        setStudentData(data.data);
      } else {
        setFullStudentData([]);
        setStudentData([]);
        console.warn("No data found for the given filters");
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const getClassName = (classId) => {
    const classObj = classes.find((cls) => cls.id === classId);
    return classObj ? classObj.classname : "N/A";
  };

  const getSectionName = (sectionId) => {
    const sectionObj = sections.find((sec) => sec.id === sectionId);
    return sectionObj ? sectionObj.sectionname : "N/A";
  };

  // const handleSelectStudent = (student) => {
  //   // Extract the student's name
  //   const studentName = `${student.studentBasicDetails.first_name} ${
  //     student.studentBasicDetails.middle_name || ""
  //   } ${student.studentBasicDetails.last_name}`;

  //   // Store the selected student's name in localStorage (or pass it to the parent via a callback)
  //   localStorage.setItem("selectedStudentName", studentName);

  //   // Call the callback function to pass the selected student name to the parent component
  //   onSelectStudent(studentName); // Make sure the parent handles this

  //   // Close the modal after selection
  //   handleClose();
  // };

  // const handleSelectStudent = (student) => {
  //   const studentId = student.studentBasicDetails.id; // Adjust this according to the actual structure of your student object

  //   // Store the selected student ID in local storage
  //   localStorage.setItem("selectedClubStudentId", studentId);

  //   // Call the callback function to pass the selected student data to the parent component
  //   onSelectStudent(student);

  //   // Close the modal after selection
  //   handleClose();
  // };

  // const handleSelectStudent = (student) => {
  //   // Use studentId (from API) instead of nested studentBasicDetails
  //   const studentId = student.studentId;

  //   // Store the selected student ID in local storage
  //   localStorage.setItem("selectedClubStudentId", studentId);

  //   // Call the callback function to pass the selected student data to the parent component
  //   if (onSelectStudent) {
  //     onSelectStudent(student);
  //   }

  //   // Close the modal after selection
  //   handleClose();
  // };

  const handleSelectStudent = (student) => {
    // Extract studentId and id from the API response
    const { studentId, id } = student;

    // Store both in local storage
    localStorage.setItem("selectedClubStudentId", studentId);
    localStorage.setItem("selectedClubRecordId", id);

    // Call the callback function to pass the selected student data to the parent component
    if (onSelectStudent) {
      onSelectStudent(student);
    }

    // Close the modal after selection
    handleClose();
  };


  // const handleSelectStudent = (student) => {
  //   // Use top-level id instead of studentId
  //   const selectedId = student.id;

  //   // Store the selected id in local storage (if needed later)
  //   localStorage.setItem("selectedClubStudentId", selectedId);

  //   // Call the callback function to pass the selected student data to the parent
  //   if (onSelectStudent) {
  //     onSelectStudent({
  //       id: selectedId,
  //       studentId: student.studentId, // keep this too if you need both
  //       admissionNo: student.school_admission_no || student.admissionNo || "",
  //       barcode: student.barcode || "",
  //       name: student.studentname,
  //       class: student.classname,
  //       section: student.sectionname,
  //       fatherName: student.father_name,
  //       motherName: student.mother_name,
  //     });
  //   }

  //   // Close the modal after selection
  //   handleClose();
  // };


  const handleClearFilters = () => {
    // Reset all filters and state variables
    setFilters({
      studentName: "",
      barcode: "",
      classId: "",
      section: "",
      fatherName: "",
      motherName: "",
      schoolAdmissionNo: "",
    });
    setSelectedClass(""); // Clear the selected class
    setSelectedSection(""); // Clear the selected section
    setStudentData(fullStudentData); // Reset the student data to the full list
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={handleClose}></Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card p-0">
                <div className="card-body">
                  <p
                    style={{
                      marginBottom: "0px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    STUDENT SEARCH
                  </p>
                  <div className="row mb-2">
                    <div
                      className="col-12  d-flex flex-wrap gap-2"
                      // style={{ border: "1px solid #ccc" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        style={{ width: "150px" }}
                        onClick={handleClearFilters}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{ width: "150px" }}
                        onClick={handleClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                  {/* Search Fields */}
                  <div className="row mt-3">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Student Name{" "}
                      </label>
                      <input
                        type="text"
                        name="studentName"
                        value={filters.studentName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Student Barcode{" "}
                      </label>
                      <input
                        type="text"
                        name="barcode"
                        value={filters.barcode}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Barcode"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }} // Inline style to set height and padding
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Class{" "}
                      </label>
                      <Select
                        options={classes.map((cls) => ({
                          label: cls.classname,
                          value: cls.id,
                        }))}
                        onChange={(selectedOption) => {
                          const classId = selectedOption?.value || "";
                          setSelectedClass(classId);
                          setSelectedSection("");
                          setFilters((prevFilters) => ({
                            ...prevFilters,
                            classId,
                            sectionId: "",
                          }));
                        }}
                        placeholder="Select Class"
                        value={
                          selectedClass
                            ? {
                                label: getClassName(selectedClass),
                                value: selectedClass,
                              }
                            : null
                        }
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Section{" "}
                      </label>
                      <Select
                        options={sections.map((sec) => ({
                          label: sec.sectionname,
                          value: sec.id,
                        }))}
                        onChange={(selectedOption) => {
                          const sectionId = selectedOption?.value || "";
                          setSelectedSection(sectionId);
                          setFilters((prevFilters) => ({
                            ...prevFilters,
                            sectionId,
                          }));
                        }}
                        placeholder="Select Section"
                        value={
                          selectedSection
                            ? {
                                label: getSectionName(selectedSection),
                                value: selectedSection,
                              }
                            : null
                        }
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Father's Name{" "}
                      </label>
                      <input
                        type="text"
                        name="fatherName"
                        value={filters.fatherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Father's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Mother's Name{" "}
                      </label>
                      <input
                        type="text"
                        name="motherName"
                        value={filters.motherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Mother's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                  </div>
                  {/* Students Table */}
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Student Name</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>Student Barcode</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentData.map((student, index) => {
                          return (
                            <tr key={index}>
                              <td>{student.studentname}</td>
                              <td>{student.classname}</td>
                              <td>{student.sectionname}</td>
                              <td>{student.father_name}</td>
                              <td>{student.mother_name}</td>
                              <td>{student.barcode}</td>
                              <td>
                                <input
                                  type="radio"
                                  name="selectedStudent"
                                  onChange={() => handleSelectStudent(student)}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectStudentModal;
